exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-divider[data-v-33d22e28]{min-width:0\n}\n@media(min-width: 992px){\n.content-divider[data-v-33d22e28]{border-left:1px solid #5a5b54;padding-left:1.5rem\n}\n}\n.filter-container[data-v-33d22e28]{background-color:#f7f6f6;border:solid 1px #d6d6d6\n}", ""]);

// exports
